import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ActionConfirmModel } from '../../../models/action-confirm.model';

@Component({
    templateUrl: './actionconfirm.component.html'
  })
  export class ActionConfirmComponent {
    
    @Input() public actionTemplate:ActionConfirmModel;
  
    constructor(
      private modalService: NgbModal,
      public activeModal: NgbActiveModal) { }
  

    confirm() {
      // Restituisco la conferma
      this.activeModal.close({ confirm: true });
    }
  
    cancel() {
      this.activeModal.close('Close click');
    }
  }